// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 1px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
  margin-top: 0;
}
@media (min-width: 991px) {
  ion-item {
    padding-inline: 3%;
  }
}
ion-item:not(:last-child) {
  margin-bottom: 12px;
}
ion-item.no-line {
  --border-color: transparent;
}

ion-input {
  --border: none !important;
  color: var(--color-black);
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent;
}

.privacy {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--color-black);
  text-transform: capitalize;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
}
.terms ion-checkbox::part(label) {
  white-space: unset;
}
@media (min-width: 991px) {
  .terms {
    padding: 0;
  }
}

ion-checkbox {
  margin-left: 0px;
  width: auto;
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}
@media (min-width: 991px) {
  .stacked {
    left: 3%;
  }
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

@media (min-width: 991px) {
  .name-row {
    padding-inline: 3%;
  }
}

.name-col {
  padding: 0;
}
@media (min-width: 991px) {
  .name-col .stacked {
    left: 0;
  }
  .name-col ion-item {
    padding-inline: 0;
  }
  .name-col:first-child {
    padding-right: 7px;
  }
  .name-col:last-child {
    padding-left: 7px;
  }
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--color-black);
}
.input-age ion-input:first-child {
  border-right: 1px solid #cbd5e1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #cbd5e1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

@media (max-width: 992px) {
  .wrapper {
    padding: 50px 15px 20px;
  }
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 64px;
    font-size: 20px;
  }
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}

.wrapper-modal {
  border: 2px solid var(--color-black);
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  background: var(--default-background);
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.wrapper-modal ion-item {
  --background: var(--default-background);
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
}
@media (min-width: 991px) {
  .wrapper-modal .close-icon {
    display: none;
  }
}
.wrapper-modal .big-close-icon {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  z-index: 99;
}
@media (max-width: 992px) {
  .wrapper-modal .big-close-icon {
    display: none;
  }
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-family: AppFontBold, sans-serif;
    font-size: 32px;
    margin-bottom: 30px;
    padding-top: 25px;
  }
}
.wrapper-modal .subtitle-text {
  display: none;
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
  letter-spacing: 0.08em;
  text-wrap: balance;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    display: block;
    font-size: 20px;
    margin-bottom: 40px;
  }
}
.wrapper-modal .header-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 40px;
  }
}

.underline {
  --border-width: 0px;
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-up/sign-up.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;AADD;;AAIA;EACC,QAAA;EACA,kBAAA;AADD;;AAGA;EACC,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACC,aAAA;AAAF;ACfE;EDSF;IASE,kBAAA;EACA;AACF;AACC;EACC,mBAAA;AACF;AAEC;EACC,2BAAA;AAAF;;AAGA;EACC,yBAAA;EACA,yBAAA;EACA,gCAAA;AAAD;;AAEA;EACC,kBAAA;EACA,yBAAA;AACD;;AAEA;EACC,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,6BAAA;AAAD;AAEC;EACC,YAAA;EACA,yBAAA;EACA,0BAAA;AAAF;;AAKA;EACC,eAAA;EACA,mBAAA;AAFD;;AAKA;EACC,oBAAA;EACA,gBAAA;AAFD;;AAKA;EACC,gBAAA;AAFD;AAGC;EACC,kBAAA;AADF;AAIC;EACC,kBAAA;AAFF;ACrEE;EDgEF;IAWE,UAAA;EAFA;AACF;;AAKA;EACC,gBAAA;EACA,WAAA;AAFD;;AAKA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAFD;ACtFE;EDoFF;IAOE,QAAA;EADA;AACF;;AAGA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACC,sBAAA;AAAF;AC7FE;EDwFF;IAQI,4BAAA;IACA,eAAA;EACF;AACF;;ACzGE;ED2GF;IAEE,kBAAA;EACA;AACF;;AACA;EACC,UAAA;AAED;ACnHE;EDmHA;IACC,OAAA;EAGD;EADA;IACC,iBAAA;EAGD;EAAA;IACC,kBAAA;EAED;EAAA;IACC,iBAAA;EAED;AACF;;AAEC;EACC,YAAA;EACA,kBAAA;EACA,yBAAA;AACF;AACC;EACC,+BAAA;AACF;AACC;EACC,8BAAA;AACF;;AAEA;EACC,yBAAA;EACA,gBAAA;AACD;;AACA;EACC,YAAA;EACA,mBAAA;AAED;;ACjJE;EDkJF;IAEI,uBAAA;EAEF;AACF;;AACA;EACC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAED;AAAC;EACC,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AACF;AC1KE;EDoKD;IAQE,gBAAA;IACA,eAAA;EAED;AACF;AADE;EACC,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAGH;;AACA;EAOC,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qCAAA;AAJD;ACzLE;EDiLF;IAEE,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;EAUA;AACF;AAHC;EACC,uCAAA;AAKF;AAHC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAKF;AClNE;EDuMD;IASE,aAAA;EAMD;AACF;AAJC;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAMF;AC1NE;ED6MD;IAUE,aAAA;EAOD;AACF;AALC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;AAOF;AC9OE;EDgOD;IASE,oCAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;EASD;AACF;AAPC;EACC,aAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AASF;ACjQE;ED+OD;IAWE,cAAA;IACA,eAAA;IACA,mBAAA;EAWD;AACF;AATC;EACC,aAAA;AAWF;AC3QE;ED+PD;IAGE,aAAA;EAaD;AACF;;AAVA;EACC,mBAAA;EACA,uBAAA;AAaD","sourcesContent":["@import '../../../theme/mixins';\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n\tgap: 5px;\n\tmargin-bottom: 8px;\n}\nion-item {\n\t--border-width: 1px !important;\n\t--border-radius: 52px !important;\n\t--border-color: #272727;\n\t--border-bottom: none;\n\tborder: none;\n  margin-top: 0;\n\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t}\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n\n\t&.no-line {\n\t\t--border-color: transparent;\n\t}\n}\nion-input {\n\t--border: none !important;\n\tcolor: var(--color-black);\n\tfont-family: AppFont, sans-serif;\n}\n.no-line {\n\tborder-bottom: 0px;\n\t--background: transparent;\n}\n\n.privacy {\n\tdisplay: flex;\n\talign-items: center;\n\n\tfont-size: 12px;\n\tcolor: var(--ion-color-black);\n\n\tion-button {\n\t\tpadding: 0px;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: capitalize;\n\t}\n}\n\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\nion-item {\n\t--border-radius: 5px;\n\tmargin-bottom: 0;\n}\n\n.terms {\n\tmargin-left: 0px;\n\tion-checkbox {\n\t\tmargin-right: 10px;\n\t}\n\n\tion-checkbox::part(label) {\n\t\twhite-space: unset;\n\t}\n\n\t@include desktop {\n\t\tpadding: 0;\n\t}\n}\n\nion-checkbox {\n\tmargin-left: 0px;\n\twidth: auto;\n}\n\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n\n\t@include desktop {\n\t\tleft: 3%;\n\t}\n}\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n  letter-spacing: 0.08em;\n\n  @include mobile {\n    font-family: AppFontSemiBold;\n    font-size: 14px;\n  }\n}\n\n.name-row {\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t}\n}\n.name-col {\n\tpadding: 0;\n\t@include desktop {\n\t\t.stacked {\n\t\t\tleft: 0;\n\t\t}\n\t\tion-item {\n\t\t\tpadding-inline: 0;\n\t\t}\n\n\t\t&:first-child {\n\t\t\tpadding-right: 7px;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-left: 7px;\n\t\t}\n\t}\n}\n.input-age {\n\tion-input {\n\t\theight: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t}\n\tion-input:first-child {\n\t\tborder-right: 1px solid #cbd5e1;\n\t}\n\tion-input:last-child {\n\t\tborder-left: 1px solid #cbd5e1;\n\t}\n}\nion-footer {\n\t--background: transparent;\n\tbox-shadow: none;\n}\n.loading {\n\theight: 50vh;\n\talign-items: center;\n}\n\n.wrapper {\n  @include mobile {\n    padding: 50px 15px 20px;\n  }\n}\n\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\twidth: 100%;\n\n\tion-button {\n\t\twidth: 100%;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\n\t\t@include desktop {\n\t\t\tmin-height: 64px;\n\t\t\tfont-size: 20px;\n\t\t}\n\t\tp {\n\t\t\tmargin-top: 5px;\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\t\t}\n\t}\n}\n.wrapper-modal {\n\t@include mobile {\n\t\tmargin-top: 25px;\n\t\tborder-bottom: none;\n\t\tborder-bottom-left-radius: 0px;\n\t\tborder-bottom-right-radius: 0px;\n\t}\n\tborder: 2px solid var(--color-black);\n\tborder-radius: 26px;\n\theight: 100%;\n\tposition: relative;\n\toverflow: auto;\n\tbackground: var(--default-background);\n\tion-item {\n\t\t--background: var(--default-background);\n\t}\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tz-index: 99;\n\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t.big-close-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tz-index: 99;\n\n\t\t@include mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\t.title-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 15px;\n\t\tletter-spacing: 0.08em;\n\t\t@include desktop {\n\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\tfont-size: 32px;\n\t\t\tmargin-bottom: 30px;\n\t\t\tpadding-top: 25px;\n\t\t}\n\t}\n\t.subtitle-text {\n\t\tdisplay: none;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tfont-family: AppFont, sans-serif;\n\t\tpadding: 10px;\n\t\tletter-spacing: 0.08em;\n\t\ttext-wrap: balance;\n\t\t@include desktop {\n\t\t\tdisplay: block;\n\t\t\tfont-size: 20px;\n\t\t\tmargin-bottom: 40px;\n\t\t}\n\t}\n\t.header-block {\n\t\tpadding: 20px;\n\t\t@include desktop {\n\t\t\tpadding: 40px;\n\t\t}\n\t}\n}\n.underline {\n\t--border-width: 0px;\n\tborder: none !important;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
